import dayjs from "dayjs";
export var initStateInvoiceData = {
    fact_new_do_id: "",
    dim_mst_invoice_status_id: "",
    dim_mst_payment_type_id: "",
    dim_mst_price_category_id: "",
    dim_new_alldernow_emp_id: "",
    fact_member_id: "",
    doc_number: "",
    do_doc_number_ref: "",
    full_member_name: "",
    full_member_address_name: "",
    member_is_hq: "",
    member_branch_no: "",
    member_additional_info: "",
    member_business_type: "",
    member_customer_type: "",
    member_address: "",
    member_district: "",
    member_amphoe: "",
    member_province: "",
    member_postal_code: "",
    member_phone_number: "",
    dim_branch_id: 3,
    refer: "",
    dim_mst_discount_type_id: 1,
    discount_value: 0,
    total_price_before_discount: 0,
    discount_price: 0,
    total_price_after_discount: 0,
    total_price_product_no_vat: 0,
    total_price_product_zero_vat: 0,
    total_price_product_seven_vat: 0,
    total_seven_vat_amount: 0,
    total_price_vat: 0,
    total_price_before_vat: 0,
    grand_total_price: 0,
    sum_item_quantity: 0,
    remark: "",
    doc_issue_date: dayjs().format("YYYY-MM-DD"),
    doc_due_date: "",
    is_sort_manual: false,
    is_tax_invoice: true,
    is_submitted: false,
    is_receipt_created: false,
    not_approve_reason: "",
    canceled_at: "",
    canceled_by_emp_id: "",
    updated_wait_approve_at: "",
    updated_approve_at: "",
    updated_success_at: "",
    submitted_at: "",
    dimMstInvoiceStatus: "",
    factNewInvPayment: []
};
